//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    SMS_SYSTEM_DELETE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    smsSystemDeleteResult,
} from 'Redux/actions';

function* deleteSmsIntegration({ payload }) {
    try {
        let QUERY = `
            mutation deleteSmsIntegration ($id: Int!) {
                result: deleteSmsIntegration (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(smsSystemDeleteResult({ delete: data?.result }))
        } else yield put(smsSystemDeleteResult({ delete: false }))

    } catch (exc) {
        yield put(smsSystemDeleteResult({ delete: false }))
        ExceptionManager(exc, 'Modules/smsSystems/views/.components/deleteSmsIntegration/redux/saga', 'deleteSmsIntegration');
    }
}

function* watchSmsIntegrationDeleteRequests() {
    yield takeEvery(SMS_SYSTEM_DELETE_REQUEST, deleteSmsIntegration);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchSmsIntegrationDeleteRequests)
    ]);
}